<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{
          $getVisibleNames("mesh.modality", false, "Modalidad de Asignaturas")
        }}
        <AlternativeNameButton
          :table_name="'mesh.modality'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_modality'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.modality',
                  false,
                  'Modalidad de Asignaturas'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-modality-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- Modalidad -->
        </div>
      </div>
      <GenericBTable
        v-if="searchModality.length > 0"
        :items="modalitiesSort"
        :pagination="modalities.length"
        :fields="modalitiesFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
      >
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.modality',
                  false,
                  'Modalidad de Asignaturas'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-modality-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <span
            v-if="
              institution &&
              institution.internal_use_id == 'duoc.cl' &&
              row.item.internal_use_id != null
            "
            v-b-tooltip.v-secondary.auto.noninteractive="
              $t('curricularDefinitions.modality.requiredForDidacticBriefcase')
            "
          >
            <ButtonSmall
              :tooltip_text="``"
              :disabled_button="true"
              :icon="'trash'"
            ></ButtonSmall>
          </span>
          <ButtonSmall
            v-else
            :click_button="() => askForDeleteModality(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.modality',
                  false,
                  'Modalidad de Asignaturas'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-modality-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.modality',
                  false,
                  'Modalidad de Asignaturas'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <ModalityForm
              :Modality="row.item"
              :Modalities="modalities"
              @updated="slotUpdatedModality"
              :show_title="false"
            ></ModalityForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
      <div v-else>
        <br />
        <strong
          >{{ $t("reusable.common.noDataFound") }}
          {{
            $getVisibleNames(
              "mesh.modality",
              false,
              "Modalidad de Asignaturas"
            ).toLowerCase()
          }}.</strong
        >
      </div>
    </div>
    <b-modal
      :id="`new-modality-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.modality',
            false,
            'Modalidad de Asignaturas'
          ),
        })
      "
      size="lg"
    >
      <ModalityForm
        :Modalities="modalities"
        @created="slotCreatedModality"
      ></ModalityForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "ModalityView",
  components: {
    ModalityForm: () =>
      import("@/components/mesh/CurricularResources/Modality/ModalityForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      modalities: names.MODALITIES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.modality",
            false,
            "Modalidad de Asignaturas"
          ),
        },
      ];
    },
    modalitiesSort() {
      let list = this.modalities;
      return list.sort((a, b) => a.order - b.order);
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_modality");
      if (has_permission) return has_permission;
      else return false;
    },
    searchModality: function () {
      return this.modalities
        .filter((item) => {
          return (
            item.name.toLowerCase().includes(this.input_search.toLowerCase()) ||
            item.description
              .toLowerCase()
              .includes(this.input_search.toLowerCase())
          );
        })
        .sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    },
    modalitiesFields() {
      if (!this.allows_crud)
        return this.modalities_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.modalities_fields;
    },
    modalities_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.modality",
              true,
              "Modalidades de Asignaturas"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: String(this.$t("reusable.common.description")),
          // sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "order",
          label: String(this.$t("reusable.common.order")),
          sortable: true,
          tdClass: "text-center",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    askForDeleteModality(modality_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.modality",
            false,
            "Modalidad de Asignaturas"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(names.DELETE_MODALITY, modality_id).then(() => {
            toast(
              String(
                this.$getVisibleNames(
                  "mesh.modality",
                  false,
                  "Modalidad de Asignaturas"
                ) +
                  " " +
                  this.$t("reusable.common.deleted")
              )
            );
          });
        }
      });
    },
    slotCreatedModality() {
      this.$bvModal.hide("new-modality-modal");
    },
    slotUpdatedModality(modality) {
      this.$bvModal.hide(`edit-modality-modal-${modality.id}`);
    },
  },
  mounted() {
    this.$store.dispatch(names.FETCH_MODALITIES);
  },
  created() {},
};
</script>

<style scoped>
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}

.title-header {
  padding: 0;
  margin-top: auto;
}
.search-modality {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>